import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@mdi/font/css/materialdesignicons.css'

import i18n from './i18n'
import theme from '../theme'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    options: {
      // Exposes the colours as CSS variables (e.g. --v-accent-base) for our own styles
      customProperties: true
    },
    themes: {
      light: {
        accent: theme.accent,
        background: theme.background,
        closed: theme.closed,
        error: '#ff5722',
        open: theme.open,
        primary: '#455a64',
        secondary: '#000000'
      }
    }
  }
})